"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=require("@material-ui/core"),l=require("@material-ui/core/Portal"),m=require("prop-types"),n=require("react"),o=require("styled-components"),b=require("../../styles/theme.js"),p=require("../../images/close.svg.js");function d(a){return a&&"object"==typeof a&&"default"in a?a:{default:a}}var u=d(l),a=d(m),q=d(n),c=d(o);let v=c.default.div`
  display: flex;
  align-items: center;
`,w=c.default.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${a=>"red"===a.color?b.theme.palette.common.red100:"blue"===a.color?b.theme.palette.common.blue100:a.color};
`;const g=({Icon:a,color:c})=>q.default.createElement(w,{color:c},"function"==typeof a?q.default.createElement(a,{color:"red"===c&&b.theme.palette.error.main}):q.default.createElement("img",{alt:"modal-icon",role:"presentation",src:a}));g.propTypes={Icon:a.default.oneOfType([a.default.func,a.default.string]),color:a.default.string};let x=c.default.button.attrs({children:q.default.createElement("img",{alt:"close-button",src:p.default})})`
  padding: 10px;
  border: none;
  background: none;
  cursor: pointer;
`;const e=({children:a,id:c})=>q.default.createElement(t.Typography,{display:"inline",id:c,style:{color:b.theme.palette.common.gray800,marginRight:"10px"},variant:"subtitle2"},a);e.propTypes={children:a.default.oneOfType([a.default.arrayOf(a.default.node),a.default.node]),id:a.default.string},e.defaultProps={id:null};let r=c.default.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${b.theme.customBorders.gray200};
  padding: ${b.theme.misc.marginMobile}px ${b.theme.misc.marginDesktop}px;
`;const h=({children:a,onClose:b})=>q.default.createElement(r,null,q.default.createElement(v,null,a),q.default.createElement(x,{onClick:b}));h.propTypes={children:a.default.oneOfType([a.default.arrayOf(a.default.node),a.default.node]),onClose:a.default.func};const i=c.default.div`
  padding: ${b.theme.misc.marginDesktop}px;
  overflow-y: auto;
  ${({height:a})=>a&&o.css`
      height: ${a};
    `}
`;let j=c.default.div`
  background-color: ${b.theme.palette.common.gray100};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 16px ${b.theme.misc.marginDesktop}px;
`;const k=({children:a})=>q.default.createElement(j,null,a);k.propTypes={children:a.default.oneOfType([a.default.arrayOf(a.default.node),a.default.node])};let y=c.default.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: ${a=>a.blurOverlay&&"blur(6px)"};
  background-color: ${a=>a.blurOverlay?"rgb(19, 30, 64, 0.6)":"rgba(0, 0, 0, 0.5)"};
  z-index: ${b.theme.zIndex.modal};
  padding: ${a=>!a.fullScreenOnMobile&&`${b.theme.misc.marginMobile}px`};
`,z=c.default.div`
  position: relative;
  margin: auto;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 64px);
  width: ${a=>a.maxWidth?`${"string"==typeof a.maxWidth?a.maxWidth:`${a.maxWidth}px`}`:"636px"};
  max-width: 100%;
  z-index: ${b.theme.zIndex.modal};
  background-color: ${b.theme.palette.common.white};
  border: ${b.theme.customBorders.gray200};
  border-radius: ${b.theme.misc.borderRadius}px;

  ${({height:a})=>a&&o.css`
      height: ${a};
      max-height: ${a};
    `}

  @media (max-width: ${b.theme.misc.mobileBreakpoint}px) {
  ${r}, ${j} {
    padding: ${b.theme.spacing(1.5,3)};
  }
  ${j} {
    justify-content: ${a=>a.fullScreenOnMobile&&"center"};
  }
    ${i} {
      flex: 1;
      padding: ${b.theme.spacing(3)}px;
    }
    ${a=>a.fullScreenOnMobile&&o.css`
        margin: 0;
        max-height: none;
        height: 100%;
        border-radius: 0;

        ${w} {
          display: none;
        }
      `}
`;function f({children:c,onClose:a,fullScreenOnMobile:b,maxWidth:d,height:e,blurOverlay:f,ariaLabelledBy:g}){let h=n.useCallback(b=>{"Escape"===b.key&&(b.stopPropagation(),b.preventDefault(),a())},[a]);return n.useEffect(()=>(document.addEventListener("keydown",h,!0),()=>{document.removeEventListener("keydown",h,!0)}),[h]),q.default.createElement(u.default,null,q.default.createElement(y,{blurOverlay:f,fullScreenOnMobile:b,onClick:a},q.default.createElement(z,{"aria-labelledby":g,fullScreenOnMobile:b,height:e,maxWidth:d,onClick:a=>a.stopPropagation()},c)))}f.propTypes={ariaLabelledBy:a.default.string,blurOverlay:a.default.bool,children:a.default.oneOfType([a.default.arrayOf(a.default.node),a.default.node]),fullScreenOnMobile:a.default.bool,height:a.default.string,maxWidth:a.default.oneOfType([a.default.string,a.default.number]),onClose:a.default.func},f.defaultProps={ariaLabelledBy:null,fullScreenOnMobile:!0,height:null};var s=c.default(f)``;exports.HeaderIcon=g,exports.InnerContent=i,exports.ModalFooter=k,exports.ModalHeader=h,exports.ModalTitle=e,exports.default=s
//# sourceMappingURL=index.js.map
